<template>
  <div class="error-page">
    <b-container>
      <b-row>
        <b-col>
          <div class="error-details">
            <div class="error-code">
              {{ code }}
            </div>
            <div class="error-message">
              {{ message }}
            </div>
            <b-btn
              v-if="code === 404"
              variant="primary"
              class="reload-page"
              size="lg"
              @click="gotoHomepage"
            >
              Return to the homepage
            </b-btn>
            <b-btn
              v-else
              variant="primary"
              class="reload-page"
              size="lg"
              @click="reloadPage"
            >
              Reload Page
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col>
          <content-creator
            :settings="getBlobContents(`error-page-${code}`)"
            :permissions="contentCreatorPermissions"
            :is-visible="editContentCreator"
            :filestore="websitefilestore"
            :name="`error-page-${code}`"
            allowed-widgets="content-grid, link-list"
            @updateBlob="(data) => saveBlob(`error-page-${code}`, data)"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import contentCreatorMixin from 'src/app/content-creator-mixin'

export default {
  name: 'error-page',
  mixins: [
    contentCreatorMixin
  ],
  props: {
    code: {
      type: [String, Number],
      required: true,
      default: '500'
    },
    customMessage: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    message() {
      if (this.customMessage !== '') {
        return this.customMessage
      }
      else {
        return this.getErrorCodeMessage()
      }
    }
  },
  watch: {
    code(val) {
      this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: false })
      this.loadBlob()
    }
  },
  created() {
    this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: false })
    this.loadBlob()
  },
  mounted() {
    this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: false })
  },
  methods: {
    getErrorCodeMessage() {
      switch (parseInt(this.code)) {
      case 401:
        return 'Unauthorized'
      case 409:
        return 'Conflict'
      case 429:
        return 'Too Many Requests'
      case 403:
        return 'Forbidden.'
      case 404:
        return 'Not Found.'
      case 500:
        return 'Internal Server Error.'
      case 503:
        return 'Service Currently Unavailable.'
      }
    },
    reloadPage() {
      this.$store.commit('DELETE_PAGE_SETTING', 'error')
    },
    loadBlob() {
      this.$store.dispatch('blob/load', {blobID: `error-page-${this.code}`, filestore: 'website', cacheOptions: { scope: 'global', ttl: 3600 * 12 }})
    },
    gotoHomepage() {
      this.$router.push('/')
    }
  },
  watch: {
    code(val) {
      this.$store.commit('SET_PAGE_SETTING', { key: 'hasHeader', value: false })
      this.loadBlob()
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-page {
    padding: 4em 0;
    .error-details {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .error-code {
        font-size: 10em;
        font-weight: 600;
        line-height: 1;
        display: flex;
        position: relative;
      }
      .error-message {
        line-height: 1;
        font-size: 1.6em;
        opacity: 0.6;
      }
    }
    .reload-page {
      margin: 4rem 0;
      padding: 1em 2em;
    }
  }
</style>
